import { useGetApReportInferences } from 'ap-openapi';

export const useGetReportInferences = (id: string, enabled: boolean) => {
  const { data, error } = useGetApReportInferences(id, {
    query: { enabled },
  });
  if (error) throw error;
  return data?.data;
};
